// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pay-invoice-modal .pay-invoice-modal-body {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.pay-invoice-modal .anticon.anticon-exclamation-circle.ant-alert-icon.gyramais-alert-icon {
  color: var(--primary-button-color) !important;
}
.pay-invoice-modal .btn-pix-copy,
.pay-invoice-modal .btn-barcode-copy {
  box-shadow: none;
}
.pay-invoice-modal .infos-invoice-row {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  justify-content: space-around;
}
@media (max-width: 768px) {
  .pay-invoice-modal .infos-invoice-row {
    margin-bottom: 1rem;
  }
}
.pay-invoice-modal .infos-invoice-row .value-wrapper {
  margin: auto !important;
  text-align: center;
}
.pay-invoice-modal .infos-invoice-row .col-infos-amount-invoice {
  display: flex;
  justify-content: flex-end !important;
  padding-right: 2rem;
}
.pay-invoice-modal .infos-invoice-row .col-infos-amount-invoice .value-wrapper {
  font-size: 2rem;
}
.pay-invoice-modal .infos-invoice-row .col-infos-due-date-invoice {
  display: flex;
  justify-content: flex-start !important;
}
.pay-invoice-modal .infos-invoice-row .col-infos-due-date-invoice .value-wrapper {
  font-size: 2rem;
}
.pay-invoice-modal .infos-invoice-row .col-infos-invoice .gyramais-information {
  margin-right: 2rem !important;
}
.pay-invoice-modal .barcode-row {
  margin-bottom: 3rem;
  text-align: center;
}
.pay-invoice-modal .barcode-row .col-barcode-image {
  text-align: center;
}
.pay-invoice-modal .barcode-row .col-barcode-image img {
  min-width: 100%;
}
.pay-invoice-modal .barcode-row .col-barcode {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pay-invoice-modal .barcode-row .col-barcode .barcode {
  font-size: 1.375rem;
  word-break: break-all;
}
.pay-invoice-modal .barcode-row .col-barcode .gyramais-btn {
  margin-left: 1rem;
}
@media (min-width: 768px) {
  .pay-invoice-modal .barcode-row .col-barcode .text-btn-barcode-copy {
    display: none;
  }
}
@media (max-width: 768px) {
  .pay-invoice-modal .barcode-row .col-barcode {
    flex-direction: column;
  }
}
.pay-invoice-modal .pix-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
}
.pay-invoice-modal .pix-row .col-pix-image {
  text-align: center;
}
.pay-invoice-modal .pix-row .col-pix-image img {
  max-width: 9.375rem;
}
.pay-invoice-modal .pix-row h2 {
  font-size: 1.375rem;
  font-weight: 400;
  color: var(--primary-button-color);
}
.pay-invoice-modal .pix-row P {
  font-size: 1.125rem;
  text-align: justify;
}
@media (min-width: 768px) {
  .pay-invoice-modal .pix-row .message-mobile {
    display: none;
  }
}
@media (max-width: 768px) {
  .pay-invoice-modal .pix-row .message-desktop {
    display: none;
  }
  .pay-invoice-modal .pix-row .btn-pix-copy {
    margin: 0 auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/PayInvoiceModal/styles.less"],"names":[],"mappings":"AAAA;EAEI,oBAAA;EACA,qBAAA;AAAJ;AAHA;EAOI,6CAAA;AADJ;AANA;;EAYI,gBAAA;AAFJ;AAVA;EAgBI,qBAAA;EACA,wBAAA;EACA,6BAAA;AAHJ;AAKI;EAAA;IACE,mBAAA;EAFJ;AACF;AApBA;EAyBM,uBAAA;EACA,kBAAA;AAFN;AAxBA;EA8BM,aAAA;EACA,oCAAA;EACA,mBAAA;AAHN;AA7BA;EAkCQ,eAAA;AAFR;AAhCA;EAsCM,aAAA;EACA,sCAAA;AAHN;AApCA;EAyCQ,eAAA;AAFR;AAvCA;EA+CQ,6BAAA;AALR;AA1CA;EAoDI,mBAAA;EACA,kBAAA;AAPJ;AA9CA;EAwDM,kBAAA;AAPN;AAjDA;EA2DQ,eAAA;AAPR;AApDA;EA+DM,aAAA;EACA,uBAAA;EACA,mBAAA;AARN;AAzDA;EAmEQ,mBAAA;EACA,qBAAA;AAPR;AA7DA;EAuEQ,iBAAA;AAPR;AASM;EAAA;IAEI,aAAA;EAPR;AACF;AASM;EAAA;IACE,sBAAA;EANN;AACF;AA1EA;EAoFI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAPJ;AAhFA;EA0FM,kBAAA;AAPN;AAnFA;EA4FQ,mBAAA;AANR;AAtFA;EAgGM,mBAAA;EACA,gBAAA;EACA,kCAAA;AAPN;AA3FA;EAqGM,mBAAA;EACA,mBAAA;AAPN;AASI;EAAA;IAEI,aAAA;EAPN;AACF;AASI;EAAA;IAEI,aAAA;EAPN;EAKE;IAKI,yBAAA;EAPN;AACF","sourcesContent":[".pay-invoice-modal {\n  .pay-invoice-modal-body {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n\n  .anticon.anticon-exclamation-circle.ant-alert-icon.gyramais-alert-icon {\n    color: var(--primary-button-color) !important;\n  }\n\n  .btn-pix-copy,\n  .btn-barcode-copy {\n    box-shadow: none;\n  }\n\n  .infos-invoice-row {\n    padding-top: 0.625rem;\n    padding-bottom: 0.625rem;\n    justify-content: space-around;\n\n    @media (max-width: 768px) {\n      margin-bottom: 1rem;\n    }\n\n    .value-wrapper {\n      margin: auto !important;\n      text-align: center;\n    }\n\n    .col-infos-amount-invoice {\n      display: flex;\n      justify-content: flex-end !important;\n      padding-right: 2rem;\n      .value-wrapper {\n        font-size: 2rem;\n      }\n    }\n    .col-infos-due-date-invoice {\n      display: flex;\n      justify-content: flex-start !important;\n      .value-wrapper {\n        font-size: 2rem;\n      }\n    }\n\n    .col-infos-invoice {\n      .gyramais-information {\n        margin-right: 2rem !important;\n      }\n    }\n  }\n  .barcode-row {\n    margin-bottom: 3rem;\n    text-align: center;\n\n    .col-barcode-image {\n      text-align: center;\n\n      img {\n        min-width: 100%;\n      }\n    }\n    .col-barcode {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .barcode {\n        font-size: 1.375rem;\n        word-break: break-all;\n      }\n      .gyramais-btn {\n        margin-left: 1rem;\n      }\n      @media (min-width: 768px) {\n        .text-btn-barcode-copy {\n          display: none;\n        }\n      }\n      @media (max-width: 768px) {\n        flex-direction: column;\n      }\n    }\n  }\n  .pix-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 3rem;\n\n    .col-pix-image {\n      text-align: center;\n      img {\n        max-width: 9.375rem;\n      }\n    }\n    h2 {\n      font-size: 1.375rem;\n      font-weight: 400;\n      color: var(--primary-button-color);\n    }\n    P {\n      font-size: 1.125rem;\n      text-align: justify;\n    }\n    @media (min-width: 768px) {\n      .message-mobile {\n        display: none;\n      }\n    }\n    @media (max-width: 768px) {\n      .message-desktop {\n        display: none;\n      }\n      .btn-pix-copy {\n        margin: 0 auto !important;\n      }\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
